import { fg } from '@confluence/feature-gating';
import { expValEquals } from '@confluence/feature-experiments';

/**
 * Returns if the current tenant has the ability to use Live Pages.
 * This takes into account multiple releases that contribute to the feature's availability.
 * @returns { boolean } Whether the Live Pages feature is enabled
 */
export const isLivePagesFeatureEnabled = (): boolean => {
	// This is allowed as this is the abstraction layer for other packages to use
	// fg('confluence_live_pages') checks if live pages are enabled
	// fg('confluence_live_pages_ab_test_opted_in') checks if live pages AB test opted in
	return fg('confluence_live_pages') || fg('confluence_live_pages_ab_test_opted_in');
};

export enum LivePageReleasePhase {
	NOT_ENABLED = 'not_enabled',
	CLOSED_BETA = 'closed_beta',
	AB_TEST_OPT_IN = 'ab_test_opt_in',
	OPEN_BETA_INITIAL = 'open_beta_initial', // Tenant is in open beta, but has never turned on the live pages.
	OPEN_BETA_DEFAULT_ON = 'open_beta_default_on', // Tenant is in open beta, and live pages have been turned on (opt in). This means the default creation method is live pages.
	OPEN_BETA_DEFAULT_OFF = 'open_beta_default_off', // Tenant is in open beta, and live pages have been turned off (opt out). Live pages are still available, but the default creation method is classic pages.
	OPEN_BETA_DISABLED = 'open_beta_disabled', // Tenant was in open beta but has asked support to disable live pages all together.
	UNKNOWN = 'unknown',
}

export const getLivePageReleasePhase = (): LivePageReleasePhase => {
	if (fg('confluence_live_pages')) {
		return LivePageReleasePhase.CLOSED_BETA;
	}

	if (fg('confluence_live_pages_ab_test_opted_in')) {
		return LivePageReleasePhase.AB_TEST_OPT_IN;
	}

	// TODO: MODES-5481 update to the correct parameter values
	if (expValEquals('confluence_live_pages_open_beta_exp', 'cohort', 'test')) {
		// TODO: MODES-5481 if trait does not exist, return OPEN_BETA_INITIAL

		// TODO: MODES-5481 if trait exists and is default on, return OPEN_BETA_DEFAULT_ON

		// TODO: MODES-5481 if trait exists and is default off, return OPEN_BETA_DEFAULT_OFF

		// TODO: MODES-5481 if trait exists and is disabled, return OPEN_BETA_DISABLED

		return LivePageReleasePhase.OPEN_BETA_INITIAL; // FIXME: MODES-5481 remove this line once the above is implemented
	}

	return LivePageReleasePhase.NOT_ENABLED;
};
